import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { ShipperResponse } from 'tms-lib';
import { ShipperBookingValidation, ShipperInterfaceHeader } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ShipperInterfaceHeaderService extends TmsWebBaseEditCreateService<
  ShipperInterfaceHeader,
  ShipperInterfaceHeader
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ShipperInterfaceHeader', $localize`Shipper Interface Header`);
  }

  bookShipping(id: string, shippingNotes: string): Observable<ShipperResponse> {
    return this.httpService.post<ShipperResponse>(`${this.apiUrl}/BookShipping`, { id, shippingNotes });
  }

  /** The checks Book Shipping makes, run on the saved record (by shipper interface id) without booking. */
  validateBooking(id: string): Observable<ShipperBookingValidation> {
    return this.httpService.get<ShipperBookingValidation>(`${this.apiUrl}/${id}/ValidateBooking`);
  }

  reprintLabel(id: string, shipperInterfaceHeaderId: string): Observable<ShipperResponse> {
    return this.httpService.post<ShipperResponse>(`${this.apiUrl}/ReprintLabel`, {
      id,
      shipperInterfaceHeaderId,
    });
  }

  changeShipper(shipperId: string, documentId: string): Observable<ShipperResponse> {
    return this.httpService.post<ShipperResponse>(`${this.apiUrl}/ChangeShipper`, { shipperId, documentId });
  }
}
